import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TopicItemProps } from "apis/topic";
import { PaginationProps } from "utils/types/API";

export interface TopicState {
    loading: boolean;
    list: {
        data: TopicItemProps[];
        options: TopicItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: TopicItemProps;
    };
}

const initialState: TopicState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: TopicItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: TopicItemProps;
}
export const topicSlice = createSlice({
    name: "topic",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = topicSlice.actions;
export default topicSlice.reducer;
